import React from 'react';

function ApplicationDevices(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-196.000000, -190.000000)">
          <g transform="translate(144.000000, 146.000000)">
            <g transform="translate(52.000000, 44.000000)" fill="#FFFFFF">
              <path
                d="M5,4 L5,21 C5,21.5522847 5.44771525,22 6,22 L18,22 C18.5522847,22 19,21.5522847 19,21 L19,8.35078106 C19,8.12370956 18.9227192,7.90339906 18.7808688,7.72608601 L15.300244,3.37530495 C15.1104718,3.13808972 14.8231589,3 14.5193752,3 L6,3 C5.44771525,3 5,3.44771525 5,4 Z"
                opacity="0.400000006"
              />
              <path
                d="M9.5,8 L14.0857864,8 C14.3510029,8 14.6053568,8.10535684 14.7928932,8.29289322 L17.2071068,10.7071068 C17.3946432,10.8946432 17.5,11.1489971 17.5,11.4142136 L17.5,19.5 C17.5,20.0522847 17.0522847,20.5 16.5,20.5 L9.5,20.5 C8.94771525,20.5 8.5,20.0522847 8.5,19.5 L8.5,9 C8.5,8.44771525 8.94771525,8 9.5,8 Z"
                opacity="0.5"
              />
              <path d="M10.5,11.5 L10.5,18.5 C10.5,18.7761424 10.7238576,19 11,19 L16,19 C16.2761424,19 16.5,18.7761424 16.5,18.5 L16.5,13.2071068 C16.5,13.0744985 16.4473216,12.9473216 16.3535534,12.8535534 L14.6464466,11.1464466 C14.5526784,11.0526784 14.4255015,11 14.2928932,11 L11,11 C10.7238576,11 10.5,11.2238576 10.5,11.5 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ApplicationDevices;
